import { safeStructuredClone } from '@storytune/chat-core/safeStructuredClone'
import merge from 'lodash/merge'
import { languageChinese } from './cn'
import { languageEnglish } from './en'

export let language: typeof languageEnglish = languageEnglish

type ResolvedLanguageCode = 'cn' | 'en'

let lastAppliedLanguageCode: ResolvedLanguageCode | undefined

function resolveLanguageCode(lang: string): ResolvedLanguageCode {
  return lang === 'cn' ? 'cn' : 'en'
}

export function getLanguageForCode(lang: string): typeof languageEnglish {
  const resolvedLanguageCode = resolveLanguageCode(lang)

  if (resolvedLanguageCode === 'cn') {
    return merge(safeStructuredClone(languageEnglish), languageChinese)
  }
  return languageEnglish
}

export function changeLanguage(lang: string) {
  const resolvedLanguageCode = resolveLanguageCode(lang)
  if (lastAppliedLanguageCode === resolvedLanguageCode) return

  language = getLanguageForCode(resolvedLanguageCode)
  lastAppliedLanguageCode = resolvedLanguageCode
}
